import { render } from "./ethetical-conscious-tannery.vue?vue&type=template&id=955a8528&scoped=true"
import script from "./ethetical-conscious-tannery.vue?vue&type=script&lang=js"
export * from "./ethetical-conscious-tannery.vue?vue&type=script&lang=js"

import "./ethetical-conscious-tannery.vue?vue&type=style&index=0&id=955a8528&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955a8528"]])

export default __exports__